import Vue from 'vue';
import {
    formatNumberPhone,
    getPhoneNumber, formatNumber,
    btoaRefactor,
} from './function';

Vue.prototype.$getEnv = (key, isNumber = false) => {
    if(isNumber){
        return process.env[key] * 1;
    }
    return process.env[key];
}

Vue.prototype.$formatNumberPhone = (phone) => {
    return formatNumberPhone(phone);
}
Vue.prototype.$formatNumber = (number) => {
    return formatNumber(number);
}
Vue.prototype.$stringToNumber = (number) => {
    return stringToNumber(number);
}
Vue.prototype.$getPhoneNumber = (phone) => {
    return getPhoneNumber(phone);
}

Vue.prototype.$encodeRedirect = (query) => {
    query = JSON.stringify(query)
    query = btoa(query);
    return query;
}

Vue.prototype.$btoa = (val) => {
    return btoaRefactor(val);
}

Vue.prototype.$decodeRedirect = (query, $url = false) => {
    try{
        let redirect = JSON.parse(atob(query));
        if($url){
            let url_return = '?';
            for(const key in redirect){
                url += key + '=' + redirect[key] + '&'
            }
            url_return = url_return.slice(0, -1);
            return url_return;
        }
        return redirect;
    }catch(e){
        if($url){
            return '';
        }
        return {};
    }
}

// Vue.prototype.$errorImage = (e) => {
//     if(e.target){
//         e.target.src = process.env.VUE_APP_BASE_ASSETS +  'images/no-img.png';
//     }else{
//         e.src = process.env.VUE_APP_BASE_ASSETS + 'images/no-img.png';
//     }
// }

Vue.directive('click-outside', {
    bind(el, binding, vNode) {
        if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}'` }
            console.warn(warn)
        }
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
                binding.value(e)
            }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
    },
    unbind(el, binding) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

    }
});

Vue.prototype.$urlImage = (image) => {
    if(image.slice(0, 1) == '/'){
        image = image.slice(1);
    }
    return process.env.VUE_APP_BASE_ASSETS + image;
}
